import type * as React from 'react';
import { contrastRatio, themes, tokens } from '@redhand/ui';
import { PageIntro, StateSection } from '../ui-helpers.js';

function Swatch({ name, value }: { readonly name: string; readonly value: string }): React.JSX.Element {
  return (
    <li className="gal-swatch">
      <div className="gal-swatch__color" style={{ background: value }} />
      <p className="gal-swatch__meta">
        <span className="gal-swatch__name">{name}</span>
        <span className="gal-swatch__value">{value}</span>
      </p>
    </li>
  );
}

export function TokensPage(): React.JSX.Element {
  return (
    <div>
      <PageIntro
        title="Tokeny a témata"
        lead="Naměřené hodnoty z referencí (pixel histogram) — plátno, akcenty, radius. Fakturace má dva kandidáty akcentu; vybere R.B. Všechny páry prochází AA verifierem theme compileru (fail-fast)."
      />
      <StateSection title="Plátno a povrchy">
        <ul className="gal-swatches">
          <Swatch name="canvas · kokpit" value={tokens.color.canvas.kokpit} />
          <Swatch name="canvas · reos" value={tokens.color.canvas.reos} />
          <Swatch name="canvas · fakturace" value={tokens.color.canvas.fakturace} />
          <Swatch name="card" value={tokens.color.card} />
          <Swatch name="border" value={tokens.color.border} />
        </ul>
      </StateSection>
      <StateSection title="Akcenty per produkt" description="Kokpit indigo, REOS modrá — naměřeno. Fakturace: kandidát A (emerald) je default, kandidát B (teal) druhá volba.">
        <ul className="gal-swatches">
          <Swatch name="kokpit" value={tokens.color.accent.kokpit} />
          <Swatch name="reos" value={tokens.color.accent.reos} />
          <Swatch name="fakturace — kandidát A" value={tokens.color.accent.fakturaceA} />
          <Swatch name="fakturace — kandidát B" value={tokens.color.accent.fakturaceB} />
        </ul>
      </StateSection>
      <StateSection title="Stavové rodiny">
        <ul className="gal-swatches">
          <Swatch name="success" value={tokens.color.success} />
          <Swatch name="success bg" value={tokens.color.successBg} />
          <Swatch name="warning" value={tokens.color.warning} />
          <Swatch name="warning bg" value={tokens.color.warningBg} />
          <Swatch name="danger" value={tokens.color.danger} />
          <Swatch name="danger bg" value={tokens.color.dangerBg} />
        </ul>
      </StateSection>
      <StateSection title="AA kontrola témat" description="Kontrast akcentu na bílé kartě (minimum 4,5:1 pro text) — počítáno živě z tokenů.">
        <table className="rh-card" style={{ borderCollapse: 'collapse', width: '100%' }}>
          <caption className="rh-sr-only">Kontrastní poměry akcentů témat</caption>
          <thead>
            <tr>
              <th scope="col" style={{ textAlign: 'left', padding: '4px 8px' }}>Téma</th>
              <th scope="col" style={{ textAlign: 'left', padding: '4px 8px' }}>Akcent</th>
              <th scope="col" style={{ textAlign: 'right', padding: '4px 8px' }}>Kontrast na kartě</th>
            </tr>
          </thead>
          <tbody>
            {themes.map((t) => (
              <tr key={t.name}>
                <td style={{ padding: '4px 8px' }}>{t.name}</td>
                <td style={{ padding: '4px 8px', fontFamily: 'ui-monospace, monospace' }}>{t.accent}</td>
                <td style={{ padding: '4px 8px', textAlign: 'right' }}>{contrastRatio(t.accent, t.card).toFixed(2)}:1</td>
              </tr>
            ))}
          </tbody>
        </table>
      </StateSection>
      <StateSection title="Radius (změřeno z reference)">
        <div className="gal-grid-2">
          <div className="rh-card" style={{ borderRadius: tokens.radius.card }}>karta — {tokens.radius.card}</div>
          <div className="rh-card" style={{ borderRadius: tokens.radius.control }}>ovládací prvek — {tokens.radius.control}</div>
          <div className="rh-card" style={{ borderRadius: tokens.radius.shell }}>vnější rám — {tokens.radius.shell}</div>
        </div>
      </StateSection>
      <StateSection title="Typografie" description="Inter variable, self-host, subset cs; --font-sans token; metric-adjusted Arial fallback. Finální font určí R.B. při review galerie.">
        <div className="rh-card">
          <p style={{ fontSize: 28, fontWeight: 650, margin: 0 }}>Příliš žluťoučký kůň úpěl ďábelské ódy</p>
          <p style={{ margin: '8px 0 0' }}>Řízení realitní kanceláře v češtině — č, ř, ž, ě, ů. 1 234 567,89 Kč.</p>
          <p style={{ margin: '8px 0 0', color: 'var(--rh-text-muted)' }}>Sekundární text v --rh-text-muted.</p>
        </div>
      </StateSection>
    </div>
  );
}
